import LongTaskErrors from 'components/LongTask/LongTaskErrors';
import LongTaskProgress from 'components/LongTask/LongTaskProgress';
import Modal from 'components/Modal';
import {
    useLongTask,
    useLongTaskFinished,
    useLongTaskPoll,
} from 'hooks/long-task';
import {FC, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {isLongTask} from 'utils/long-task';
import {setUrl} from 'utils/request';
import {onApiError} from 'utils/request-axios/utils';

import {CatalogLineItemBackend} from '../../types';
import {useDeleteAllLineItems} from './services';

type UseDeleteAllLineItemsModal = () => {
    isModalOpen: boolean;
    setIsModalOpen: (isOpen: boolean) => void;
};
export const useDeleteAllLineItemsModal: UseDeleteAllLineItemsModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return {isModalOpen, setIsModalOpen};
};

type ExportHistoryDataModalProps = {
    isModalOpen: boolean;
    setIsModalOpen: (isOpen: boolean) => void;
};
const DeleteAllCatalogItems: FC<ExportHistoryDataModalProps> = ({
    isModalOpen,
    setIsModalOpen,
}) => {
    const methods = useFormContext();

    const {data} = useBackend<CatalogLineItemBackend>();

    const longTaskMethods = useLongTask({
        defaultLongTask: data.uiLongTask,
    });
    useLongTaskPoll(longTaskMethods);
    useLongTaskFinished(longTaskMethods, {
        onError: () => {},
        onSuccess: () => {
            setUrl(window.Urls.catalog_view());
        },
    });

    const deleteAllApi = useDeleteAllLineItems();

    const handleDelete = async () => {
        await deleteAllApi
            .mutateAsync({})
            .then(({data}) => {
                if (!isLongTask(data))
                    throw new Error('Expected a long task response');
                longTaskMethods.setLongTask(data.uilongtask);
            })
            .catch(onApiError(methods));
    };

    const isProcessing = !!longTaskMethods.longTask;

    return (
        <Modal
            isOpen={isModalOpen || isProcessing}
            onClose={() => setIsModalOpen(false)}
        >
            <Modal.Header>
                <div className="flex items-center justify-between">
                    <div>{t`Delete All Catalog Items`}</div>
                    {!isProcessing && (
                        <Modal.Button
                            icon="close"
                            kind="tertiary"
                            onClick={() => setIsModalOpen(false)}
                            size="sm"
                            type="cancel"
                        />
                    )}
                </div>
            </Modal.Header>
            <Modal.Body>
                {!longTaskMethods.longTask && (
                    <>
                        <p>
                            {t`Deleting Catalog Items will automatically remove all linkings with the corresponding Catalog Line Items from Document Line Items. If Product Code was set on the Catalog Line Items, you are not able to track Product Code on Document Line Items anymore.`}
                        </p>
                        <p>{t`Are you sure you want to delete all of the Catalog Items?`}</p>
                    </>
                )}
                {longTaskMethods.longTask && (
                    <>
                        <LongTaskProgress longTask={longTaskMethods.longTask} />
                        <LongTaskErrors UiLongTask={longTaskMethods.longTask} />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Modal.Button
                    disabled={!!longTaskMethods.longTask}
                    kind="destructive"
                    onClick={handleDelete}
                    size="sm"
                    type="submit"
                >
                    {t`Delete All Catalog Items`}
                </Modal.Button>
            </Modal.Footer>
        </Modal>
    );
};
export default DeleteAllCatalogItems;
